import { useCallback } from 'react'
import {
  LazyQueryHookOptions,
  QueryLazyOptions,
  useLazyQuery,
} from '@apollo/client'

import {
  GetItems_getItems_items as ItemType,
  GetItemsVariables,
} from 'types/gql-types/GetItems'

import { GetItems } from './graphql/getItems'

interface GetItemsResponse {
  getItems: {
    items: ItemType[] | null
    nextToken: string | null
  }
}

export const useGetItems = (
  hookOptions?: LazyQueryHookOptions<GetItemsResponse, GetItemsVariables>
) => {
  const [getQuery, { data, fetchMore, loading: isLoading }] = useLazyQuery<
    GetItemsResponse,
    GetItemsVariables
  >(GetItems, hookOptions)

  const items = data?.getItems.items
  const nextToken = data?.getItems.nextToken

  const getItems = useCallback(
    (queryOptions?: QueryLazyOptions<GetItemsVariables>) => {
      getQuery(queryOptions)
    },
    [getQuery]
  )

  const loadMore = useCallback(() => {
    fetchMore?.({ variables: { nextToken } })
  }, [fetchMore, nextToken])

  return {
    getItems,
    hasMore: Boolean(nextToken),
    isLoading,
    items,
    loadMore,
    nextToken,
  }
}
